import styled from 'styled-components';

import { StediPayer } from 'models/StediPayer';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

const MAX_STATES_LISTED = 5;

const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export function payerDetails({ operatingStates, coverageTypes }: StediPayer) {
  const states = operatingStates.length > MAX_STATES_LISTED ? `${operatingStates.length}` : operatingStates.join(', ');

  return [
    states && `States: ${states}`,
    coverageTypes.length > 0 && `Lines: ${coverageTypes.map(capitalize).join(', ')}`,
  ]
    .filter(Boolean)
    .join(' • ');
}

// A payer search result: its name, then what it covers. Never its ids.
export function StediPayerOptionLabel({ payer }: { payer: StediPayer }) {
  return (
    <>
      <div>{payer.name}</div>
      <Details>{payerDetails(payer)}</Details>
    </>
  );
}

export function PayerSearchUnavailable({ children }: { children: string }) {
  return <Unavailable data-testid='payer-search-unavailable'>{children}</Unavailable>;
}

const Details = styled.div`
  font-size: 12px;
  color: ${colors.black50};
`;

const Unavailable = styled(BodySmall)`
  margin-top: 4px;
  color: ${colors.black50};
`;
